<div class="container" [ngClass]="[bgImage]">
    <div class="message">
        <span class="title">404</span>
        <span class="subtitle">{{"404 MESSAGE" | translate}}</span>
        <app-demo-button text="{{'HOMEPAGE' | translate}}" color="page-404" url="/"></app-demo-button>
    </div>
</div>
